import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RootState, selectors, actions } from '../store';
import PlaceList from '../components/PlaceList';
import SkeletonLoading from '../components/SkeletonLoading';
import EditUser from '../components/EditUser';
import { RouteComponentProps } from "react-router";
import { checkbox, heart, clipboard, camera, person } from 'ionicons/icons';
import {
  withIonLifeCycle, IonInfiniteScroll, IonInfiniteScrollContent,
  IonPage, IonToast, IonHeader, IonToolbar, IonIcon, IonLabel, IonTitle,
  IonButtons, IonModal, IonSegment, IonSegmentButton, IonAvatar, IonItem,
  IonContent, IonRefresher, IonRefresherContent,
  IonMenuButton,
} from '@ionic/react';
import localForage from 'localforage';
import './HomePage.css';
import { getQueryByVariable } from '../utils';
import { Token } from '../store/users/types';
import { isloggedIn } from '../store/users/selectors';

type Props =  RouteComponentProps<{}> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>;

type State = {
  segment: string,
  isRefreshing: boolean,
  showLoading: boolean,
  showModal: boolean,
  loadingMessage: string
}

class Profile extends Component<Props, State> {
  state = {
    segment: 'visited',
    isRefreshing: false,
    showLoading: false,
    showModal: false,
    loadingMessage: '',
    totalCount: 496,
  }

  constructor(props: Props) {
    super(props);
    props.updateTagFilters(['visited']);
  }

  componentDidMount = async () => {

  }
  async ionViewDidEnter() {
    // only for mobile app
    // const el = document.getElementsByTagName("ion-app")[0];
    // if (el) {
    //   (el as HTMLElement)['style'].marginTop = '50px';
    // }
    const queryParams: string = (window.location.search || '').substr(1) || '';
    const signout = getQueryByVariable(queryParams, 'signout');
    if (signout) {
      await localForage.removeItem('tokens');
      this.props.signout();
      return;
    }
    if (this.props.tokens && this.props.tokens.id_token) {
      const { refreshList } = this.props;
      if (refreshList !== '') {
        this.props.getList(this.props.tokens, refreshList);
      }
      return;
    }
    // const tokens: Token = await localForage.getItem('tokens');
    // console.log(this.props)
    // if (tokens && tokens.refresh_token) {
    //   const { refreshList } = this.props;
    //   if (refreshList !== '') {
    //     this.props.getList(tokens, refreshList);
    //   }
    //   // this.props.getUserInfo(tokens);
    //   return;
    // }
    
		const code = getQueryByVariable(queryParams, 'code');
		if (code) {
      await this.props.getTokensFromCode(code);
      window.history.replaceState({}, document.title, '/profile');
    }
  }

  componentDidUpdate = async (prevProps: Props) => {
  }

  updateSearchTerm = (e: CustomEvent) => {
    this.props.searchPlacesInVisited(e.detail.value);
    // this.props.setSearchText(e.detail.value);
  }

  updateSegment = (e: CustomEvent) => {
    const { value } = e.detail;
    this.setState((prevState) => ({
      ...prevState,
      segment: value
    }));
    this.props.updateTagFilters([value]);
    const { getList, tokens, isLoggedIn } = this.props;
    if (!isLoggedIn) {
      return;
    }
    if (!this.props[value].loaded) {
      getList(tokens, value);
    }
  }


  doRefresh = (e: CustomEvent) => {
    // const { getAnswers, selectedQuestion } = this.props;
    // getAnswers(selectedQuestion.id);
    e && (e.target as any).complete();
  }

  showModal = () => {
    this.setState(() => ({
      showModal: true
    }));
  };

  dismissModal = () => {
    this.setState(() => ({
      showModal: false
    }));
  };

  updateName = (data: any) => {
    // console.log(data)
    // this.props.updateUser(data);
  }

  loadMoreUserListParks = (e: CustomEvent) => {
    const { nextKey } = this.props[this.state.segment];
    this.props.getList(this.props.tokens, this.state.segment, nextKey);
    e && (e.target as any).complete();
  }
  navigateToPhotoDetails = (parkCode: string, photoId: string) => {
    // this.props.history.push(`${this.props.match.url}/photos/${photoId}`);
    this.props.history.push(`/profile/places/${parkCode}/photos/${photoId}`);
  }
  render() {
    const { visitedCount, favoritesCount, bucketListCount} = this.props.listCount;
    const { bucket_count, visited_count, favorites_count, photo_count } = this.props.userProfile;
    // const totalCountText = `${this.props.listCount.visitedCount}`;
    // const favoriteCountText = `${this.props.listCount.favoritesCount}`;
    // const bucketCountText = `${this.props.listCount.bucketListCount}`;
    const totalCountText = `${visited_count || visitedCount}`;
    const favoriteCountText = `${favorites_count || favoritesCount}`;
    const bucketCountText = `${bucket_count || bucketListCount}`;
    // this.props[`${this.state.segment}Parks`].parks
    
    // let message = '';
    // if (this.props.searchText === '') {
    //   message = "No favorites added.";
    //   if (this.state.segment === 'visited') {
    //     message = "You haven't visited a park yet."
    //   }
    // } else if (this.props.searchText !== '') {
    //   message = "No parks found with your search";
    // }
    return (
      <>
      <IonPage id="main">
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>Profile</IonTitle>
            <IonButtons slot="start">
                {/* <IonButton onClick={this.presentFilter}>
                  <IonIcon icon={menu} />
                </IonButton> */}
                <IonMenuButton></IonMenuButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonModal
          isOpen={this.state.showModal}
          onDidDismiss={this.dismissModal}
        >
          <EditUser
            name={this.props.userProfile.name}
            email={this.props.userProfile.email}
            username={this.props.userProfile.username}
            updateName={this.updateName}
            dismissModal={this.dismissModal}
          />
        </IonModal>
        <IonContent>
          <IonRefresher
            closeDuration="2000ms"
            slot="fixed" onIonRefresh={(e: CustomEvent) => this.doRefresh(e)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          <IonItem>
            <IonAvatar color="light" className="avatarBg">
              <IonIcon size="large" color="dark" icon={person} />
              {/* <img src="https://gravatar.com/avatar/dba6bae8c566f9d4041fb9cd9ada7741?d=identicon&f=y" /> */}
            </IonAvatar>
            <IonLabel className="paddingLeft">
              {/* <b><a className="floatRight" href={url}>Sign up</a></b> */}
              <p>
                {this.props.userProfile.username} <br />
                {this.props.userProfile.name} <br/>
              </p>
            </IonLabel>
          </IonItem>
          <IonSegment color="dark" value={this.state.segment} onIonChange={this.updateSegment}>
            <IonSegmentButton value="visited">
              <IonIcon color="primary" icon={checkbox} />
              <IonLabel className="badge-count">{totalCountText}</IonLabel>
              {/* <IonLabel  color="dark">{totalCountText}</IonLabel> */}
            </IonSegmentButton>
            <IonSegmentButton value="favorites">
              <IonIcon  color="danger" icon={heart} /><IonLabel className="badge-count">{favoriteCountText}</IonLabel>
              {/* <IonLabel  color="dark">{favoriteCountText}</IonLabel> */}
            </IonSegmentButton>
            <IonSegmentButton value="bucket">
              <IonIcon color="secondary" icon={clipboard} />
              <IonLabel className="badge-count">{bucketCountText}</IonLabel>
              {/* <IonLabel  color="dark">{bucketCountText}</IonLabel> */}
            </IonSegmentButton>
            <IonSegmentButton value="photos">
              <IonIcon color="gray" icon={camera} />
              <IonLabel className="badge-count">{photo_count}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
          {/* <IonToolbar>
             <IonSearchbar
              placeholder="Search"
              onIonChange={this.updateSearchTerm}
            >
            </IonSearchbar>
          </IonToolbar> */}
          <IonToast
            isOpen={this.state.isRefreshing}
            message="Updating content..."
            duration={2000}
            onDidDismiss={() => this.setState(() => ({ isRefreshing: false }))}
          ></IonToast>
          <SkeletonLoading loading={this.props.usersListLoading || this.props.loading} />
          <PlaceList
            places={this.props.filteredPark}
            isLoggedIn={this.props.isLoggedIn}
            visited={this.props.visited.parks}
            bucket={this.props.bucket.parks}
            favorites={this.props.favorites.parks}
            photos={this.props.photos.photos}
            photoDetailsFn={this.navigateToPhotoDetails}
            hidden={false}
            listType={this.state.segment}
          />
          {
            this.props.isLoggedIn ?
            <>
            <IonInfiniteScroll
              disabled={!this.props[this.state.segment].nextKey}
              threshold="100px" onIonInfinite={this.loadMoreUserListParks}>
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="Loading more data..." />
            </IonInfiniteScroll>
            <SkeletonLoading loading={this.props[this.state.segment].loading} />
            </>
            :
            <></>
          }
        </IonContent>
      </IonPage>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  // favoritesFiltered: selectors.places.favoritesFiltered(state.places),
  refreshList: state.users.refreshList,
  photos: state.users.photos,
  visited: state.users.visited,
  bucket: state.users.bucket,
  favorites: state.users.favorites,
  listCount: selectors.places.listCount(state.places),
  filteredPark: selectors.places.filteredPark(state.places),
  loading: state.places.loading,
  usersListLoading: state.users.loading,
  userProfile: state.users.loggedInUser,
  tokens: state.users.tokens,
  isLoggedIn: state.users.loggedIn,
  myList: state.places.myList,
  allTags: selectors.places.allTags(state.places)
});

const mapDispatchToProps = {
  signout: () => actions.users.signoutAction(),
  getMyList: () => actions.places.getMyList(),
  syncUser: (tokens: Token, places: any) => actions.users.syncUser(tokens, places),
  fetchAllParks: () => actions.places.fetchAllParks(),
  getTokens: () => actions.users.getTokens(),
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  getUserInfo: (tokens: Token) => actions.users.getUserInfo(tokens),
  getList: (tokens: Token, type: string, nextKey?: string) => actions.users.getList(tokens, type, nextKey),
  getTokensFromCode: (code: string) => actions.users.getTokensFromCode(code),
  updateTagFilters: (tags: string[]) => actions.places.updateTagFilters(tags),
  searchPlacesInVisited: (searchText: string) => actions.places.setSearchTextInVisited(searchText),
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withIonLifeCycle(Profile));
